var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_588",
    "data-name": "Group 588",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.359,
    height: 31.528,
    viewBox: "0 0 27.359 31.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path--gear"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 27.359,
    height: 31.528,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path--gear)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_518",
    "data-name": "Path 518",
    d: "M22.5,7.6a3.8,3.8,0,1,1,3.8-3.8,3.8,3.8,0,0,1-3.8,3.8m0-6.539A2.741,2.741,0,1,0,25.246,3.8,2.745,2.745,0,0,0,22.5,1.057",
    transform: "translate(1.057 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_519",
    "data-name": "Path 519",
    d: "M17.792,30.335a4.614,4.614,0,1,1,4.614-4.614,4.619,4.619,0,0,1-4.614,4.614m0-8.171a3.557,3.557,0,1,0,3.557,3.557,3.561,3.561,0,0,0-3.557-3.557",
    transform: "translate(0.745 1.193)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_520",
    "data-name": "Path 520",
    d: "M17.65,27.533A1.954,1.954,0,1,1,19.6,25.58a1.957,1.957,0,0,1-1.955,1.953m0-2.852a.9.9,0,1,0,.9.9.9.9,0,0,0-.9-.9",
    transform: "translate(0.887 1.335)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    d: "M9.063,21.493a9.062,9.062,0,1,1,9.062-9.062,9.073,9.073,0,0,1-9.062,9.062m0-17.068a8.006,8.006,0,1,0,8.005,8.006A8.016,8.016,0,0,0,9.063,4.426",
    transform: "translate(0 0.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    d: "M8.862,17.534a5.3,5.3,0,1,1,5.3-5.3,5.31,5.31,0,0,1-5.3,5.3m0-9.551a4.247,4.247,0,1,0,4.247,4.248A4.252,4.252,0,0,0,8.862,7.984",
    transform: "translate(0.201 0.392)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    d: "M8.606,6.737a.528.528,0,0,1-.528-.528V3.9a.528.528,0,0,1,1.057,0V6.209a.528.528,0,0,1-.528.528",
    transform: "translate(0.457 0.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    d: "M5.723,7.51a.53.53,0,0,1-.459-.264l-1.155-2a.528.528,0,0,1,.915-.528l1.156,2a.528.528,0,0,1-.194.722.515.515,0,0,1-.263.071",
    transform: "translate(0.228 0.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    d: "M3.611,9.62a.522.522,0,0,1-.264-.071l-2-1.156a.528.528,0,1,1,.528-.914l2,1.155a.528.528,0,0,1-.264.986",
    transform: "translate(0.061 0.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    d: "M2.84,12.5H.528a.528.528,0,1,1,0-1.057H2.84a.528.528,0,1,1,0,1.057",
    transform: "translate(0 0.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    d: "M1.611,16.6a.528.528,0,0,1-.264-.986l2-1.155a.528.528,0,1,1,.528.914l-2,1.156a.522.522,0,0,1-.264.071",
    transform: "translate(0.061 0.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_528",
    "data-name": "Path 528",
    d: "M4.566,19.606a.515.515,0,0,1-.263-.071.528.528,0,0,1-.194-.722l1.156-2a.528.528,0,0,1,.915.528l-1.155,2a.53.53,0,0,1-.459.264",
    transform: "translate(0.228 0.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_529",
    "data-name": "Path 529",
    d: "M8.606,20.7a.528.528,0,0,1-.528-.528V17.864a.528.528,0,0,1,1.057,0v2.312a.528.528,0,0,1-.528.528",
    transform: "translate(0.457 0.98)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_530",
    "data-name": "Path 530",
    d: "M12.707,19.606a.53.53,0,0,1-.459-.264l-1.155-2a.528.528,0,0,1,.915-.528l1.156,2a.528.528,0,0,1-.193.722.522.522,0,0,1-.264.071",
    transform: "translate(0.623 0.935)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_531",
    "data-name": "Path 531",
    d: "M15.707,16.6a.515.515,0,0,1-.263-.071l-2-1.156a.528.528,0,1,1,.528-.914l2,1.155a.529.529,0,0,1-.265.986",
    transform: "translate(0.745 0.813)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_532",
    "data-name": "Path 532",
    d: "M16.807,12.5H14.5a.528.528,0,1,1,0-1.057h2.311a.528.528,0,1,1,0,1.057",
    transform: "translate(0.789 0.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_533",
    "data-name": "Path 533",
    d: "M13.707,9.62a.528.528,0,0,1-.264-.986l2-1.155a.528.528,0,0,1,.528.914l-2,1.156a.522.522,0,0,1-.264.071",
    transform: "translate(0.745 0.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_534",
    "data-name": "Path 534",
    d: "M11.55,7.51a.515.515,0,0,1-.263-.071.528.528,0,0,1-.194-.722l1.156-2a.528.528,0,0,1,.915.528l-1.155,2a.53.53,0,0,1-.459.264",
    transform: "translate(0.623 0.252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_535",
    "data-name": "Path 535",
    d: "M8.7,14.416a2.343,2.343,0,1,1,2.343-2.343A2.347,2.347,0,0,1,8.7,14.416m0-3.63A1.287,1.287,0,1,0,9.99,12.072,1.288,1.288,0,0,0,8.7,10.786",
    transform: "translate(0.359 0.55)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_536",
    "data-name": "Path 536",
    d: "M6.887,4.805a.528.528,0,0,1-.12-1.042L22.142.146a.521.521,0,0,1,.635.393.526.526,0,0,1-.394.634L7.009,4.79a.478.478,0,0,1-.121.015",
    transform: "translate(0.359 0.008)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_537",
    "data-name": "Path 537",
    d: "M21.442,27.242a.615.615,0,0,1-.1-.008.53.53,0,0,1-.424-.616l4.168-22.63a.529.529,0,0,1,1.041.192L21.961,26.81a.53.53,0,0,1-.519.432",
    transform: "translate(1.182 0.201)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_538",
    "data-name": "Path 538",
    d: "M15.308,29.136a.527.527,0,0,1-.349-.131L2.741,18.262a.529.529,0,0,1,.7-.794L15.656,28.211a.529.529,0,0,1-.349.926",
    transform: "translate(0.145 0.98)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGear);
export default __webpack_public_path__ + "static/media/gear.54eba9119bbab956b34e37ff1dd80f26.svg";
export { ForwardRef as ReactComponent };